import { render, staticRenderFns } from "./ContactReferralPartnerTable.vue?vue&type=template&id=95efa52e&scoped=true"
import script from "./ContactReferralPartnerTable.vue?vue&type=script&lang=js"
export * from "./ContactReferralPartnerTable.vue?vue&type=script&lang=js"
import style0 from "./ContactReferralPartnerTable.vue?vue&type=style&index=0&id=95efa52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95efa52e",
  null
  
)

export default component.exports